import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'root',
      redirect: { name: 'main' }
    }, {
      path: '/main',
      name: 'main',
      component: (resolve) => {
        require(['../pages/main.vue'], resolve)
      }
    }, {
      path: '/inherinext',
      name: 'inherinext',
      component: (resolve) => {
        require(['../pages/inherinext.vue'], resolve)
      }
    }, {
      path: '/introduction',
      name: 'introduction',
      component: (resolve) => {
        require(['../pages/introduction.vue'], resolve)
      }
    // }, {
    //   path: '/seminar',
    //   name: 'seminar',
    //   component: (resolve) => {
    //     require(['../pages/seminar.vue'], resolve)
    //   }
    }, {
      path: '*',
      redirect: { name: 'main' }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js